import { render, staticRenderFns } from "./LandingComponent.html?vue&type=template&id=03132296&external"
import script from "./LandingComponent.js?vue&type=script&lang=js&external"
export * from "./LandingComponent.js?vue&type=script&lang=js&external"
import style0 from "./LandingComponent.styl?vue&type=style&index=0&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03132296')) {
      api.createRecord('03132296', component.options)
    } else {
      api.reload('03132296', component.options)
    }
    module.hot.accept("./LandingComponent.html?vue&type=template&id=03132296&external", function () {
      api.rerender('03132296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/.vuepress/components/LandingComponent/index.vue"
export default component.exports